import { Stack, Grid } from '@mui/material';
import Box from '@mui/material/Box';
import { useMediaQuery, useTheme } from '@mui/material';
import { motion } from 'framer-motion'; // Import framer-motion
import Banner1 from './1stBanner';
import Banner2 from './2ndBanner';
import Banner3 from './3rdBanner';
import Banner3Responsive from './3rdBannerResponsive';
import Banner4 from './4thBanner';
import Banner4Responsive from './4thBannerResponsive';
import Banner5 from './5thBanner';
import Banner6 from './6thBanner';
import Banner7 from './7thBanner';
import Banner7Responsive from './7thBannerResponsive';
import Banner8 from './8thBanner';
import Banner9 from './9thBanner';
import Banner9Responsive from './9thBannerResponsive';
import FooterFull from './Footer';
import FooterFul2 from './Footer2';
import Slides from './Slide';

function App() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('845'));

  // Define scroll animation configuration
  const scrollVariants = {
    hidden: { opacity: 0, y: 100 }, // start offscreen (below)
    visible: { opacity: 1, y: 0, transition: { duration: 1.0 } } // animates upward
  };

  return (
    <Box sx={{ backgroundColor: 'black' }}>
      <Grid container spacing={0} direction="column">
        <Grid item xs={12}>
          <Slides />
        </Grid>
        <Grid item xs={12}>
          <motion.div initial="hidden" whileInView="visible" variants={scrollVariants}>
            <Banner2 />
          </motion.div>
        </Grid>
        <Grid item xs={12}>
          {isMobile ? (
            <motion.div initial="hidden" whileInView="visible" variants={scrollVariants}>
              <Banner3Responsive />
            </motion.div>
          ) : (
            <motion.div initial="hidden" whileInView="visible" variants={scrollVariants}>
              <Banner3 />
            </motion.div>
          )}
        </Grid>
        <Grid item xs={12}>
          <motion.div initial="hidden" whileInView="visible" variants={scrollVariants}>
            <Banner4 />
          </motion.div>
        </Grid>
        <Grid item xs={12}>
          <motion.div initial="hidden" whileInView="visible" variants={scrollVariants}>
            <Banner5 />
          </motion.div>
        </Grid>
        <Grid item xs={12}>
          <motion.div initial="hidden" whileInView="visible" variants={scrollVariants}>
            <Banner6 />
          </motion.div>
        </Grid>
        <Grid item xs={12}>
          {isMobile ? (
            <motion.div initial="hidden" whileInView="visible" variants={scrollVariants}>
              <Banner7Responsive />
            </motion.div>
          ) : (
            <motion.div initial="hidden" whileInView="visible" variants={scrollVariants}>
              <Banner7 />
            </motion.div>
          )}
        </Grid>
        <Grid item xs={12}>
          {!isMobile && (
            <motion.div initial="hidden" whileInView="visible" variants={scrollVariants}>
              <Banner8 />
            </motion.div>
          )}
        </Grid>
        <Grid item xs={12}>
          <motion.div initial="hidden" whileInView="visible" variants={scrollVariants}>
            <Banner9 />
          </motion.div>
        </Grid>
        <Grid item xs={12}>
          <FooterFull />
        </Grid>
        {/* <Grid item xs={12} sx={{ md: 2 }}>
          <FooterFul2 />
        </Grid> */}
      </Grid>
    </Box>
  );
}

export default App;
